export interface EmergencyContactData {
  id: number;
  name: string;
  primaryPhone: string;
  secondaryPhone: string | null;
  email: string | null;
  userId: number;
}

export const initialEmergencyContactData: EmergencyContactData = {
  id: 0,
  name: "",
  primaryPhone: "",
  secondaryPhone: null,
  email: null,
  userId: 0,
};
